import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CommentsList } from '@widgets/shared/Comments/CommentsList/index.tsx';
import { useUser } from '@shared/hooks/index.ts';
import { useRecommendedProgramQuery } from '@src/api/api-hooks/programs/useRecommendedProgramQuery.ts';
import { Loader } from '@src/library/components/common/index.ts';

type PT = {};
export const RecommendedProgramComments = ({}: PT) => {
  const { hash } = useParams();

  const { data, isError } = useRecommendedProgramQuery({ hash: Boolean(hash) ? hash : undefined });

  const { user } = useUser();
  const isContentAuthor = useMemo(() => user?.id === data?.invite?.program.author.id, [data, user]);

  if (isError) {
    return 'SomeErrorHasOccured';
  }

  return data?.invite?.program ? (
    <CommentsList
      isPaid={data.invite.program.is_paid || data.invite.program.cost_base === 0}
      isContentAuthor={isContentAuthor}
      comments={data.invite.program.comments}
      program={Number(data.invite.program.pk)}
    />
  ) : (
    <Loader />
  );
};
